import { render, staticRenderFns } from "./enPrivacy.vue?vue&type=template&id=e195438c&scoped=true&"
import script from "./enPrivacy.vue?vue&type=script&lang=js&"
export * from "./enPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./enPrivacy.vue?vue&type=style&index=0&id=e195438c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e195438c",
  null
  
)

export default component.exports